
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import ModalUserData from '@/components/templates/manage/ModalUserData.vue'
import { SelectItem } from '@/models/SelectItem'
import PasswordUtils from '@/utils/PasswordUtils'
import { AcademiesApi } from '@/api/methods/manage/AcademiesApi'
import { UserAcademiesApi } from '@/api/methods/manage/UserAcademiesApi'
import StringUtils from '@/utils/StringUtils'

/**
 * 塾管理者登録モーダル
 */
@Component({
  components: {
    ModalUserData,
  },
})
export default class ModalRegistUserAcademy extends Vue {
  /** ユーザ情報モーダルのフォーマット */
  @Ref()
  modalUserData!: ModalUserData

  /** 塾管理者更新後の処理 */
  @Prop()
  private afterUpdateUserAcademy!: () => Promise<void>

  /** 塾フィルターの固定値「未選択」 */
  private readonly OPTION_NOT_SELECTED = { value: '', label: '未選択' }

  /** 塾一覧 */
  private academyList: SelectItem[] = []

  /** 塾フィルターの初期値 */
  private defaultAcademyCode: string = ''

  /**
   * 送信ボタンのdisabled制御
   *
   * @param nickname ニックネーム
   * @param password パスワード
   * @param confirm 確認用パスワード
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(nickname: string, password: string, confirm: string): boolean {
    // ニックネームが未入力の場合true
    if (StringUtils.isBlank(nickname)) {
      return true
    }

    // パスワードが未入力の場合true
    if (!password) {
      return true
    }

    // 確認用パスワードが未入力の場合true
    if (!confirm) {
      return true
    }

    // 塾が未選択の場合true
    if (this.currentAcademy() === this.OPTION_NOT_SELECTED.value || StringUtils.isBlank(this.currentAcademy())) {
      return true
    }

    return false
  }

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // パスワードのバリデーションチェック
    errorMessage = this.validPassword()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    errorMessage = PasswordUtils.checkPasswordEnabled(this.modalUserData.password)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 塾管理者ユーザ登録
    await UserAcademiesApi.createUserAcademy(
      this.modalUserData.nickname,
      this.modalUserData.password,
      Number(this.currentAcademy())
    )

    // 塾管理者更新後の処理
    //   メソッド内で塾管理者一覧の再取得を行う
    await this.afterUpdateUserAcademy()

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()
  }

  /**
   * 選択中の塾
   *
   * @returns 塾コード(ID)
   */
  private currentAcademy(): string {
    return this.modalUserData.selectedValue()
  }

  /**
   * パスワードのバリデーションチェック
   *
   * @returns 確認用パスワードと一致しない場合はエラーメッセージを返す
   */
  private validPassword(): string | null {
    if (this.modalUserData.password !== this.modalUserData.confirm) {
      return 'パスワードと確認用パスワードが一致しません'
    }

    return null
  }

  /**
   * モーダルを開く
   */
  public async show(): Promise<void> {
    this.$loading.start()

    // 塾一覧取得
    const academies = await AcademiesApi.getAcademies()

    // 塾プルダウン設定
    this.academyList = academies.map((academy) => {
      return {
        // 塾IDをコードとして使用
        value: String(academy.id),
        label: academy.name,
      }
    })

    // 塾フィルターの先頭に「未選択」を設定
    this.academyList.unshift(this.OPTION_NOT_SELECTED)

    // 塾フィルターの初期値を設定
    this.defaultAcademyCode = this.academyList[0].value

    // モーダルを開く
    this.modalUserData.show()

    this.$loading.complete()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalUserData.hide()
  }
}
